import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "tile-modal-inner hide-scrollbar",
  ref: "innerModal"
}
const _hoisted_2 = { class: "modal-hub" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "cls-1",
    d: "M33.6,155.6a14.7,14.7,0,0,1-20.7,0l-.5-.6a14.7,14.7,0,0,1,0-20.7L89.6,57.1a14.7,14.7,0,0,1,20.7,0h.1l77.2,77.2a14.7,14.7,0,0,1,0,20.7l-.5.6a14.7,14.7,0,0,1-20.7,0l-66-66a.5.5,0,0,0-.8,0Z"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "design-proj-inner" }
const _hoisted_6 = { class: "modal-hub" }
const _hoisted_7 = ["src", "data-src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TileDisplay = _resolveComponent("TileDisplay")!
  const _component_CloseBtn = _resolveComponent("CloseBtn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tile-modal design-modal", _ctx.data.designClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TileDisplay, { data: _ctx.data }, null, 8, ["data"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-scroll-top glass-tile", {'show-scroll-btn': _ctx.showModalScrollbtn}]),
          ref: "modalScrollTop",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.modalToTop && _ctx.modalToTop(...args)))
        }, _hoisted_4, 2),
        _createVNode(_component_CloseBtn, {
          glassTile: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (
                        _ctx.scrollTopModal(),
                        _ctx.$emit('hideModals')
                    ))
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["modal-content wrapper", {'scroll-content': _ctx.data.scrollContent}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.designs, (design, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "design-project",
            ref_for: true,
            ref: "designTile",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.tileModal && _ctx.tileModal(...args)), ["self"])),
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: "toggle-modal-bg",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleModalBg && _ctx.toggleModalBg(...args)))
                }),
                _createVNode(_component_CloseBtn, {
                  glassTile: false,
                  onClick: _ctx.hideDesignModals
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", {
                class: "design-proj-img-outer",
                ref_for: true,
                ref: "designImgOuter"
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass(["design-proj-img", {
                                    'mobile-design': design.isMobile && _ctx.containsObjects,
                                    'desktop-design': !design.isMobile && _ctx.containsObjects
                                }]),
                  ref_for: true,
                  ref: "designProjImg",
                  src: _ctx.placeholderImg,
                  "data-src": !_ctx.containsObjects ? design : design.img,
                  alt: "Design Project",
                  loading: "lazy"
                }, null, 10, _hoisted_7)
              ], 512)
            ])
          ]))
        }), 128))
      ], 2)
    ], 512)
  ], 2))
}